import store from '@/store'

import async from 'async'

import restResource from '@/technical/restResource'

// import treeviewData from '@/technical/components/Treeview/treeviewData'
// import treeviewDataMethods from '@/technical/components/Treeview/treeviewDataMethods'

import serverData from '@/store/serverData'

export default function (options, callback) {
  if (options == null) return callback(null)

  serverData.loadingDataStatus.mainCommonData = serverData.loadingDataStatus.types.LOADING

  async.parallel({
    // /////////////////////////////////////////////////////////////////

    users: function (cb) {
      if ((options.all === false) && (options.users === false)) return cb(null, true)
      if ((options.all === true) || (options.users === true)) {} else return cb(null, true)
      // console.log('users')
      var users = {}
      var usersThatExist = {}
      var userResource = restResource(store.getters.appSettings.server.host + store.getters.appSettings.server.userResource)
      userResource.query()
      .then(function (response) {
        if (response.data == null) return cb('что-то не так')
        for (var itemIndx = 0; itemIndx < response.data.length; itemIndx++) {
          users[response.data[itemIndx].id] = response.data[itemIndx]
          if (response.data[itemIndx].Deleted === 0) usersThatExist[response.data[itemIndx].id] = response.data[itemIndx]
        }
        /* arrayTools.sort(users, function (a, b) {
          return a.Name < b.Name
        }) */
        store.commit('commonDataUsersSet', users)
        store.commit('commonDataUsersThatExistSet', usersThatExist)
        cb(null, true)
      })
      .catch((error) => cb(error))
    },

    // /////////////////////////////////////////////////////////////////

    usersGroups: function (cb) {
      if ((options.all === false) && (options.usersGroups === false)) return cb(null, true)
      if ((options.all === true) || (options.usersGroups === true)) {} else return cb(null, true)
      // console.log('usersGroups')
      var usersGroups = {}
      var userGroupResource = restResource(store.getters.appSettings.server.host + store.getters.appSettings.server.userGroupResource)
      userGroupResource.query()
      .then(function (response) {
        if (response.data == null) return cb('что-то не так')
        for (var itemIndx = 0; itemIndx < response.data.length; itemIndx++) {
          usersGroups[response.data[itemIndx].id] = response.data[itemIndx]
        }
        store.commit('commonDataUsersGroupsSet', usersGroups)
        cb(null, true)
      })
      .catch((error) => cb(error))
    },

    // /////////////////////////////////////////////////////////////////
    /*
    partners: function (cb) {
      if ((options.all === false) && (options.partners === false)) return cb(null, true)
      if ((options.all === true) || (options.partners === true)) {} else return cb(null, true)

      serverData.partnersReload(function (error) {
        if (error) return cb(error)
        cb(null, true)
      })
    },
    */
    // /////////////////////////////////////////////////////////////////

    appSettings: function (cb) {
      if ((options.all === false) && (options.appSettings === false)) return cb(null, true)
      if ((options.all === true) || (options.appSettings === true)) {} else return cb(null, true)

      serverData.appSettingsReload(function (error) {
        if (error) return cb(error)
        cb(null, true)
      })
    }

      // /////////////////////////////////////////////////////////////////
  }, function (error, results) { // results: {users: true, news: true}
    if (error) serverData.loadingDataStatus.mainCommonData = serverData.loadingDataStatus.types.ERROR
    else serverData.mainCommonDataLoadedSetTrue()

    callback(error)
  })
}



// WEBPACK FOOTER //
// ./src/components/mainCommonDataLoader.js